import format from 'date-fns/format';
import produce from 'immer';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Alerts,
  Button,
  Checkbox,
  InputDropdown,
  Pagination,
  Table,
  TableCell,
  TableHeader,
  TableRow,
  Tooltip,
  WrapperFlex,
} from '@unimed-fesp/components';

import { MdAdb, MdExpandMore, MdInfo } from 'react-icons/md';

import theme from '../../../styles/theme';

import { ContainerEmptyContent, HoverActions } from './styles';

import { StatusListaRPAEnum } from '../../../enums';

import FadeIn from '../../atoms/FadeIn';
import Icon from '../../atoms/Icon';
// TO-DO trocar por dropdown type button da lib
import ButtonDropdown from '../../atoms/ButtonDropdown';

import LoadingSpinning from '../../molecules/LoadingSpinning';

const { REACT_APP_MOVCAD_LEGACY } = process.env;

function TabTableListasRPA({
  setPaginationParams,
  paginationParams,
  handlePageChangeKeyDown,
  handleConfirmAction,
  dropdownOptions,
  handleDropdownItem,
  handleChangePage,
  handleChangeTab,
}) {
  const { listasRpa, statusLists } = useSelector((state) => state.lista);
  const status = statusLists.response.actives;

  function handleRender(listaStatus, tabName = null) {
    const tipoStatus = StatusListaRPAEnum.returnNameForTab[tabName] || 0;
    if (listasRpa.loading) {
      return <LoadingSpinning />;
    }
    if (listaStatus.data && listaStatus.data.length > 0) {
      return (
        <TableLista
          pageData={listaStatus}
          listas={listaStatus.data}
          setPaginationParams={setPaginationParams}
          paginationParams={paginationParams}
          handlePageChangeKeyDown={handlePageChangeKeyDown}
          handleConfirmAction={handleConfirmAction}
          listasSize={listaStatus.totalCount}
          dropdownOptions={dropdownOptions}
          handleDropdownItem={handleDropdownItem}
          handleChangePage={(params) => handleChangePage(params, tipoStatus)}
          {...(tabName && { tabName })}
        />
      );
    }
    return <EmptyContent />;
  }

  useEffect(() => {
    const newPaginationParams = produce(paginationParams, (draft) => {
      draft.pageSize = 10;
      draft.pageNumber = 1;
    });

    setPaginationParams(newPaginationParams);
  }, [status]);

  return <>{handleRender(listasRpa.response, 'Todas')}</>;
}

const TableListaHeader = ({ checkAll, handleCheckAll }) => {
  return (
    <TableRow>
      <TableHeader widthAuto>
        <Checkbox
          checked={checkAll}
          onClick={(e) => handleCheckAll(e)}
          height={18}
          width={18}
        />
      </TableHeader>
      <TableHeader minWidth={100} maxWidth={120}>
        Lista
      </TableHeader>
      <TableHeader minWidth={100} maxWidth={120}>
        Contratante
      </TableHeader>
      <TableHeader minWidth={100} maxWidth={120}>
        Movimentação
      </TableHeader>
      <TableHeader minWidth={100} maxWidth={120}>
        Criação
      </TableHeader>
      <TableHeader minWidth={100} maxWidth={120}>
        Envio
      </TableHeader>
      <TableHeader minWidth={100} maxWidth={120}>
        Finalização
      </TableHeader>
      <TableHeader minWidth={100} maxWidth={120}>
        Status
      </TableHeader>
      <TableHeader maxWidth={16} minWidth={16} />
    </TableRow>
  );
};

const TableLista = ({
  listas,
  pageData,
  setPaginationParams,
  paginationParams,
  handlePageChangeKeyDown,
  handleConfirmAction,
  tabName,
  listasSize,
  dropdownOptions,
  handleDropdownItem,
  handleChangePage,
}) => {
  const [checkAll, setCheckAll] = useState(false);
  const [listaRowsChecked, setListaRowsChecked] = useState([]);
  function handleCheckAll(e) {
    setCheckAll(!checkAll);
  }

  return (
    <>
      <FadeIn height="auto" width="100%">
        {listaRowsChecked.length > 0 ? (
          <FadeIn height="auto" width="100%">
            <SetAllLista
              listaRowsChecked={listaRowsChecked}
              paginationParams={paginationParams}
              totalSize={listasSize}
              marginLeft="20px"
              dropdownOptions={dropdownOptions}
              handleConfirmAction={handleConfirmAction}
            />
          </FadeIn>
        ) : null}
        <Table
          head={
            <TableListaHeader
              checkAll={checkAll}
              handleCheckAll={handleCheckAll}
            />
          }
        >
          {listas.map((lista) => (
            <TableContent
              key={lista.idLista}
              lista={lista}
              checkAll={checkAll}
              setListaRowsChecked={setListaRowsChecked}
              listaRowsChecked={listaRowsChecked}
              handleConfirmAction={handleConfirmAction}
              tabName={tabName}
              dropdownOptions={dropdownOptions}
              handleDropdownItem={handleDropdownItem}
            />
          ))}
        </Table>
      </FadeIn>
      {pageData.totalCount > 10 && (
        <Pagination
          total={pageData.totalCount}
          paginationParams={paginationParams}
          callbackChangePage={handleChangePage}
          setPaginationParams={setPaginationParams}
          handlePageChangeKeyDown={handlePageChangeKeyDown}
        />
      )}
    </>
  );
};

const TableContent = ({
  lista,
  checkAll,
  setListaRowsChecked,
  listaRowsChecked = [],
  handleConfirmAction,
  tabName,
  dropdownOptions,
  handleDropdownItem,
}) => {
  const [hoverAction, setHoverAction] = useState(false);
  const [isChecked, setIsChecked] = useState(true);
  const [list, setList] = useState({ lista, checked: !isChecked });

  function handleMouseEnterHover(e) {
    setHoverAction(!hoverAction);
  }

  function handleMouseLeaveHover(e) {
    if (hoverAction) setHoverAction(!hoverAction);
  }

  function redirectToDetalheLista(idLista) {
    window.location.replace(
      `${REACT_APP_MOVCAD_LEGACY}/CadastrarLista.aspx?idLista=${idLista}`
    );
  }

  function handleCheckedLista(e, check, idLista) {
    const newLista = produce(list, (draft) => {
      if (draft.lista.idLista === idLista) draft.checked = !check;

      return draft;
    });

    const newListaRowChecked = produce(listaRowsChecked, (draft) => {
      const newDraft = draft.filter((l) => {
        return l.lista.idLista !== newLista.lista.idLista && l.checked === true;
      });

      if (newLista.checked) newDraft.push(newLista);

      draft = newDraft;

      return draft;
    });

    setList(newLista);
    setListaRowsChecked(newListaRowChecked);
  }

  useEffect(() => {
    const newLista = produce(list, (draft) => {
      draft.checked = checkAll;

      return draft;
    });
    setList(newLista);
    if (checkAll) {
      if (
        !listaRowsChecked
          .map((listaRowChecked) => listaRowChecked.lista.idLista)
          .includes(newLista.lista.idLista)
      )
        setListaRowsChecked((oldArray) => [...oldArray, newLista]);
    } else setListaRowsChecked([]);
  }, [checkAll]);

  return (
    <TableRow
      onMouseEnter={handleMouseEnterHover}
      onMouseLeave={handleMouseLeaveHover}
      key={lista.idLista}
    >
      <TableCell widthAuto key={lista.idLista}>
        <Checkbox
          checked={list.checked}
          onClick={(e) => handleCheckedLista(e, list.checked, lista.idLista)}
          height={18}
          width={18}
        />
      </TableCell>
      <TableCell
        onClick={() => redirectToDetalheLista(lista.idLista)}
        activeAction
        minWidth={100}
        maxWidth={100}
      >
        {lista.nmLista}
      </TableCell>
      <TableCell minWidth={100} maxWidth={100}>
        {lista.cdContratante} - {lista.nmContratante}
      </TableCell>
      <TableCell minWidth={137} maxWidth={137}>
        {lista.dcMovimentacoes.split('/').join(' / ')}
      </TableCell>
      <TableCell minWidth={100} maxWidth={100}>
        {lista.dtInclusao
          ? format(new Date(lista.dtInclusao), 'dd/MM/yyyy HH:mm', {
              timeZone: 'America/Sao_Paulo',
            })
          : null}
      </TableCell>
      <TableCell minWidth={100} maxWidth={100}>
        {lista.dtEnvio
          ? format(new Date(lista.dtEnvio), 'dd/MM/yyyy HH:mm')
          : null}
      </TableCell>
      <TableCell minWidth={100} maxWidth={100}>
        {lista.dtVencimento
          ? format(new Date(lista.dtVencimento), 'dd/MM/yyyy HH:mm')
          : null}
      </TableCell>
      <TableCell minWidth={100} maxWidth={100}>
        {hoverAction ? (
          <TableListaActions
            redirectToDetalheLista={() => redirectToDetalheLista(lista.idLista)}
            idLista={lista.idLista}
            listaStatus={lista.dcStatusRpa}
            handleConfirmAction={handleConfirmAction}
            dropdownOptions={dropdownOptions}
            handleDropdownItem={handleDropdownItem}
          />
        ) : (
          lista.dcStatusRpa
        )}
      </TableCell>
      <TableCell>
        {lista.possuiSinalizacao && (
          <Tooltip
            background={theme.greenDefault}
            color={theme.white}
            text="Lista contém beneficiários excluídos com motivo de cancelamento “RN 412 – Cancelamento/Exclusão a Pedido”"
            position="left"
          >
            <HoverActions>
              <MdInfo size="17" color={theme.movYellowDefault} />
            </HoverActions>
          </Tooltip>
        )}
      </TableCell>
    </TableRow>
  );
};

const EmptyContent = () => (
  <WrapperFlex fullHeight justifyCenter alignCenter>
    <ContainerEmptyContent>Nenhum registro localizado</ContainerEmptyContent>
  </WrapperFlex>
);

const SetAllLista = ({
  listaRowsChecked,
  paginationParams,
  marginLeft,
  totalSize,
  dropdownOptions,
  handleConfirmAction,
}) => {
  return (
    <WrapperFlex marginBottom={25} alignCenter>
      <Alerts width={650} type="success">
        <span>
          Você selecionou {listaRowsChecked.length} de{' '}
          {totalSize >= 10 ? paginationParams.pageSize : totalSize} itens.
        </span>
      </Alerts>
      {/* <ButtonBorder
        justifySpaceBetween
        alignCenter
        width="123"
        padding={10}
        marginLeft={marginLeft}
      >
        <MdFileDownload size="20" stroke={theme.greenDefault} />
        download
      </ButtonBorder>
      <ButtonBorder
        justifySpaceBetween
        alignCenter
        width="101"
        padding={10}
        marginLeft="16px"
      >
        <Icon size="25" color={theme.greenDefault} icon="deleteOutline" />
        excluir
      </ButtonBorder> */}
      <Button
        tipo="secondary"
        justifySpaceBetween
        alignCenter
        width={155}
        paddingTop={10}
        paddingRight={10}
        paddingBottom={10}
        paddingLeft={10}
        padding={10}
        marginLeft={16}
        font="16px unimed_slabregular"
        onClick={() => handleConfirmAction(listaRowsChecked, 'cancelar')}
      >
        <Icon size="25" color={theme.greenDefault} icon="cancelOutline" />
        cancelar RPA
      </Button>
      <InputDropdown
        placeHolder="Pesquise e selecione o status RPA"
        options={Object.values(dropdownOptions)}
        handleClickOption={(option) => {
          const indexOption = Object.values(dropdownOptions).indexOf(option);

          handleConfirmAction(listaRowsChecked, indexOption + 1);
        }}
        position="right-bottom"
      >
        <ButtonDropdown
          marginLeft="16px"
          padding={0}
          text="status RPA"
          width="103"
          secondaryIcon={<MdExpandMore size="20" color="#FFF" />}
        />
      </InputDropdown>
    </WrapperFlex>
  );
};

const TableListaActions = ({
  idLista,
  listaStatus,
  handleConfirmAction,
  dropdownOptions,
  handleDropdownItem,
}) => {
  return (
    <WrapperFlex alignCenter justifySpaceEvenly>
      <InputDropdown
        options={Object.values(dropdownOptions)}
        placeHolder="Pesquise e selecione o status RPA"
        position="right-bottom"
        handleClickOption={(option) => {
          const indexOption = Object.values(dropdownOptions).indexOf(option);

          handleConfirmAction(idLista, indexOption + 1);
        }}
      >
        <Tooltip
          background={theme.greenDefault}
          color={theme.bgWhite}
          text="ações RPA"
          position="bottom"
        >
          <HoverActions>
            <MdAdb size="22" color={theme.colorGray} />
          </HoverActions>
        </Tooltip>
      </InputDropdown>
      {/* <HoverActions
        data-tip="download"
        onClick={() => handleConfirmAction(idLista, listaStatus)}
      >
        <MdFileDownload size="22" color={theme.colorGray} />
      </HoverActions> */}
      <Tooltip
        background={theme.greenDefault}
        color={theme.bgWhite}
        text="cancelar processo RPA"
        position="bottom"
      >
        <HoverActions onClick={() => handleConfirmAction(idLista, 'cancelar')}>
          <Icon size="22" color={theme.colorGray} icon="cancelOutline" />
        </HoverActions>
      </Tooltip>
    </WrapperFlex>
  );
};
export default TabTableListasRPA;
